import { useMemo, useState } from "react"

import { useParams } from "react-router-dom"

import { REFERENTIAL_MAP_ID } from "@l2r-front/l2r-map"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { Typography, UiModal, useIsMobileDevice } from "@l2r-front/l2r-ui"

import { LINEAR_LOCATION_ROAD, LINEAR_LOCATION_SECTION } from "../../constants/linearLocation"
import { useSubNetworksWithWriteAccess } from "../../contexts/NetworksContext"

import { SelectableReferentialLayer } from "../SelectableReferentialLayer"

import * as Styled from "./LinearLocationSelector.styled"

export function LinearLocationSelector(props) {

    const {
        cancelButtonLabel,
        className,
        desc,
        initialBoundingBox,
        module,
        onCancel,
        onValidateLinearLocation,
        selectionType,
        title,
        titleIcon,
        validateButtonLabel,
    } = props

    const { road } = useParams()
    const isMobile = useIsMobileDevice()
    const [selectedLinearLocation, setSelectedLinearLocation] = useState((road && selectionType === LINEAR_LOCATION_ROAD) ? { road } : null)
    const subNetworks = useSubNetworksWithWriteAccess(null, module)

    const buttons = useMemo(() => {
        return <>
            <Styled.Button id="linearLocation-selection-cancel" isMobile={isMobile} variant="tertiary" onClick={onCancel}>{cancelButtonLabel}</Styled.Button>
            <Styled.Button id="linearLocation-selection-ok" isMobile={isMobile} disabled={!selectedLinearLocation} onClick={() => onValidateLinearLocation(selectedLinearLocation)}>{validateButtonLabel}</Styled.Button>
        </>
    }, [cancelButtonLabel, isMobile, onCancel, onValidateLinearLocation, selectedLinearLocation, validateButtonLabel])

    return <UiModal
        buttons={buttons}
        className={className}
        desc={desc}
        open={!!selectionType}
        onClose={onCancel}
        title={title}
        titleIcon={titleIcon}
    >
        <Styled.ReferentialMap
            className={className}
            initialBoundingBox={initialBoundingBox}
        >
            <Styled.SelectedInfos>
                <Typography variant="Desktop & Mobile/Body/Small">{selectedLinearLocation?.road}</Typography>
            </Styled.SelectedInfos>
            <SelectableReferentialLayer
                mapId={REFERENTIAL_MAP_ID}
                onLinearLocationChanged={setSelectedLinearLocation}
                selectedLinearLocation={selectedLinearLocation}
                selectionType={selectionType}
                subNetworks={subNetworks}
            />
        </Styled.ReferentialMap>
    </UiModal>
}

LinearLocationSelector.propTypes = {
    cancelButtonLabel: PropTypes.string.isRequired,
    className: PropTypes.string,
    desc: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onValidateLinearLocation: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    titleIcon: PropTypes.node,
    selectionType: PropTypes.oneOf([LINEAR_LOCATION_ROAD, LINEAR_LOCATION_SECTION]),
    validateButtonLabel: PropTypes.string.isRequired,
}

LinearLocationSelector.defaultProps = {
    selectionType: LINEAR_LOCATION_ROAD,
}